//@flow

export const roundOff = (val: number, dec: number): number =>
  Number(Math.round(val + 'e' + dec) + 'e-' + dec);

export const getAverage = (ratings: Object) => {
  if (!ratings) return;

  const ratingsCameForSelfGuidedTrek = Object.keys(ratings).length === 1;
  if (ratingsCameForSelfGuidedTrek) {
    // return the first value of the key in the object
    return roundOff(Number(Object.values(ratings)[0]) / 2, 2);
  }

  let totalStars = 0;
  const numberOfStars = 10;

  for (let key in ratings) {
    totalStars += Number(ratings[key]);
  }

  return roundOff(totalStars / numberOfStars, 2);
};

export const computeDistanceFromTop = args => {
  let element = '',
    x = 0;

  if (!args) throw new Error('Args expected should be string or object');

  // if the id is passed
  if (typeof args === 'string') element = document.getElementById(args);

  //if the refs is passed
  if (typeof args === 'object') element = args;

  while (element) {
    x = x + element.offsetTop;
    element = element.offsetParent;
  }

  return x;
};

export const scrollWindowTo = (elementY, duration) => {
  var startingY = window.pageYOffset;
  var diff = elementY - startingY;
  var start;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed milliseconds since start of scrolling.
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);

    window.scrollTo(0, startingY + diff * percent);
    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};

/**
 * Used in Img tags. onError loading original image changes the src attribute to a fallback url
 * @param {browser event object} event
 * @param {string} fallbackImageUrl
 */
export const useFallbackImage = (e: Object, fallbackImageUrl: string) => {
  e.target.onerror = null;
  e.target.src = fallbackImageUrl;
};
